import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

const ENDPOINT = "Comunicados";

// Enum espelhado de api/Models/Matriz/Comunicado.cs
const TipoComunicado = {
    AvisoSistema: 1,
    InformativoUnidade: 2,
    Alerta: 3,
};

// Padroniza o retorno do crudeApiService em { ok, data, message }.
// O helper retorna undefined quando a sessao expira (recarrega a pagina) e,
// nos erros de POST, a mensagem pode vir como objeto { status, message }.
const normalizarResultado = (promise) =>
    Promise.resolve(promise).then((result) => {
        if (!result) {
            return { ok: false, data: null, message: "" };
        }
        const ok = result.status >= 200 && result.status < 300;
        const message = result.message && typeof result.message === "object"
            ? result.message.message
            : result.message;
        return { ok, data: result.data, message: message || "" };
    });

const queryEstabelecimento = (estabelecimentoId) =>
    estabelecimentoId ? `?estabelecimentoId=${encodeURIComponent(estabelecimentoId)}` : "";

// Comunicados ativos destinados ao usuario logado, aceitos ou pendentes (ComunicadoMuralDto)
const listarMural = (estabelecimentoId) =>
    normalizarResultado(UseGetApiSimple(`${ENDPOINT}/mural${queryEstabelecimento(estabelecimentoId)}`));

// Registro "li e concordo" do usuario logado (o usuario vem do token, nunca do body); idempotente no servidor
const aceitar = (comunicadoId, estabelecimentoId) =>
    normalizarResultado(UsePostApi(`${ENDPOINT}/${comunicadoId}/aceitar${queryEstabelecimento(estabelecimentoId)}`, {}));

export { TipoComunicado, listarMural, aceitar };
